import React from 'react';

import DashboardLayout from '../layouts/Dashboard/Dashboard';
import Dashboard from '../components/Dashboard/Dashboard';
import { toAccount, notifications } from '../components/Dashboard/testData';
import {setPageTitle} from '../utils/helpers';
import withFeatureFlags from "../components/FeatureFlags/withFeatureFlags";

const DashboardPageContainer = (/** @type {{ featureEnabled?: (flag: string) => boolean }} */ { featureEnabled }) => {
  setPageTitle('Dashboard | Investec Save');
  
  return (
    <DashboardLayout notifications={notifications}>
      <Dashboard toAccount={toAccount}/>
    </DashboardLayout>
  );

};

export default withFeatureFlags(DashboardPageContainer);
